import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import {reduxForm, setSubmitFailed, setSubmitSucceeded} from 'redux-form'
import {connect} from 'react-redux'
import {pathOr, isEmpty} from 'ramda'

import {pushFiltersApply, pushSearchSubmitError} from '../../../../../helpers/gtm'

import codeApply from '../../../actions/filters/professionalCode'
import codeChange from '../../../actions/filters/codeChange'
import syncFilters from '../../../../shared/actions/syncFilters'
import {
  SEARCH_FILTERS_FORM,
  FILTER_DATES,
  FILTER_ROOMS,
  FILTER_CODE,
  DESTINATIONS_PAGE_VIEW,
  HOMEPAGE_VIEW,
  SEARCHPAGE_VIEW
} from '../../../constants'
import {updateDatesInSearchString,
  updateDatesInSearchStringBooking,
  getFilledRooms,
} from '../../../utils'
import setSearchUrlHolder from '../../../actions/setSearchUrlHolder'
import './wrapper.scss'
import toggleGlobalLoader from "../../../../loader/actions/loaderActions"
import Button from 'js/components/shared/Button';

const pageView = pathOr(null, ['drupalSettings', 'pageView'], window)
const isSearchPage = pageView === SEARCHPAGE_VIEW

class Wrapper extends PureComponent {
  static propTypes = {
    filterType: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.any,
    ]),
    title: PropTypes.string.isRequired,
    applyTitle: PropTypes.string.isRequired,
    closeLink: PropTypes.string.isRequired,
    onFilterClose: PropTypes.func.isRequired,
    isFilterFilled: PropTypes.bool.isRequired,
    isFilterApplied: PropTypes.bool.isRequired,
    filterApplyAction: PropTypes.func.isRequired,
    isFilterClearable: PropTypes.bool.isRequired,
    clearLabel: PropTypes.string,
    onFilterClear: PropTypes.func.isRequired,
    setSubmitFailedAction: PropTypes.func.isRequired,
    setSubmitSucceededAction: PropTypes.func.isRequired,
    codeApplyAction: PropTypes.func.isRequired,
    codeChangeAction: PropTypes.func.isRequired,

    orientation: PropTypes.string,
    isLessThanMedium: PropTypes.bool,
    syncFiltersAction: PropTypes.func.isRequired,
    searchFilters: PropTypes.objectOf(Object),
    link2FirstStep: PropTypes.string,
    filterChangeAction: PropTypes.func.isRequired,
    bookingUrl: PropTypes.string,
    formData: PropTypes.objectOf(Object),
    pageIndex: PropTypes.number,
  }

  static defaultProps = {
    children: null,
    clearLabel: '',
    orientation: null,
    isLessThanMedium: null,
    link2FirstStep: null,
    reserveBtnUrl: null,
    bookingUrl: null,
    homePageVideoBanner: false,
    searchFilters: {},
    formData: null,
    pageIndex: 0,
  }

  state = {
    top: null,
    isHomePage: pageView === HOMEPAGE_VIEW,
  }

  componentDidMount = () => {
    this.headerBottom()
    this.onToggleCookieBanner()
  }

  onToggleCookieBanner = () => {
    document.body.addEventListener('closeCookieBanner', () => this.headerBottom())
  }

  onSubmitHandler = (e) => {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    const {
      syncFiltersAction,
      filterApplyAction,
      onFilterClose,
      filterType,
      setSubmitFailedAction,
      setSubmitSucceededAction,
      codeApplyAction,
      codeChangeAction,
      searchFilters,
      link2FirstStep,
      filterChangeAction,
      bookingUrl,
      pageIndex,
      formData,
      formInfo = {},
      toggleGlobalLoaderAction,
    } = this.props

    const {
      syncErrors = {}
    } = formInfo;

    pushFiltersApply(filterType)

    if (isEmpty(syncErrors)) {
      if (filterType === 'code') {
        const codeData = pathOr({}, ['searchFilters', 'code'], this.props)

        codeApplyAction(codeData).then(() => {
          toggleGlobalLoaderAction(false)
          window.location.reload()
        }).catch((error) => {
          if (codeData.clientCode !== '' || codeData.contractNumber !== '') {
            codeChangeAction('error', error)
            pushSearchSubmitError({
              errorType: 'invalid value',
              errorField: 'client code, contract number'
            })
          } else {
            codeChangeAction('errorPromo', error)
            pushSearchSubmitError({
              errorType: 'invalid value',
              errorField: 'promo'
            })
          }
          filterChangeAction('activeFilter', FILTER_CODE)

        })
      } else {
        setSubmitSucceededAction(SEARCH_FILTERS_FORM)
        filterApplyAction(filterType, true, true).then(() => {
          const {dates, additionalValues} = searchFilters
          if (filterType === 'dates' && pageIndex === 10) { // hotel page
            const rooms = getFilledRooms(formData)
            window.location = updateDatesInSearchStringBooking(window.location.href, dates, rooms)

          } else if (filterType === 'dates' && link2FirstStep) {
            const url = updateDatesInSearchString(link2FirstStep, dates)
            window.location.href = url
          } else if (isSearchPage && bookingUrl.length > 0) {
            const url = updateDatesInSearchString(bookingUrl, dates)
            window.location.href = url
          } else if (filterType === 'dates' && additionalValues && additionalValues.url && additionalValues.url !== "#") {
            window.location.href = updateDatesInSearchString(additionalValues.url, dates)
          } else {
            syncFiltersAction(true)
          }
        })
        onFilterClose(e)
      }
    } else {
      setSubmitFailedAction(SEARCH_FILTERS_FORM, Object.keys(syncErrors))
    }
  }

  isSubmitDisabled = () => {
    const {
      isFilterFilled,
      isFilterApplied,
      filterType,
    } = this.props

    let codeFiltersFilledOk = true
    let isDisabled = false

    if (filterType === 'code') {
      const codeData = pathOr({}, ['searchFilters', 'code'], this.props)
      if (codeData.clientCode !== '' &&  codeData.contractNumber === '' ||
        codeData.clientCode === '' &&  codeData.contractNumber !== '') {
        codeFiltersFilledOk = false
      }
    }

    if (!codeFiltersFilledOk) {
      isDisabled = true
    } else if (!isFilterFilled && !isFilterApplied) {
      isDisabled = true
    }

    return isDisabled
  }

  headerBottom = () => (
    setTimeout(() => {
      const {bottom} = document.querySelector('.site-header').getBoundingClientRect()
      const {isLessThanMedium} = this.props
      this.setState({
        top: bottom >= 0 && !isLessThanMedium ? bottom : 0,
      })
    }, 100)
  )

  render() {
    const {
      children,
      applyTitle,
      isFilterFilled,
      isFilterApplied,
      filterType,
      orientation,
    } = this.props

    const childrenWithProps = React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          onSubmitHandler: this.onSubmitHandler,
        })
      }
      return child
    })

    return (
      <React.Fragment>
        <div className={cn('filter-wrapper', `filter-wrapper-${filterType}`)}>
          <div className="filter-wrapper-block">
            <div className="filter-wrapper-block__container">
              <form role="search" className="filter-block-form__wrapper" onSubmit={this.onSubmitHandler}>

                {childrenWithProps}

                {filterType !== FILTER_DATES && (
                  <div className={`filter-block-footer ${filterType} ${orientation}`}>
                    <Button
                      theme="squared"
                      color="black"
                      size="lg"
                      type="submit"
                      disabled={this.isSubmitDisabled()}
                    >
                      {applyTitle}
                    </Button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  ({
     main: {
       bookingUrl,
       homePageVideoBanner,
       pageIndex,
     },
     browser,
     browser: {
       orientation,
       lessThan: {
         medium: isLessThanMedium,
       },
     },
     form: {
       searchFilters,
       [SEARCH_FILTERS_FORM]: formInfo,
     },
     form,
   }) => ({
    searchFilters,
    formInfo,
    orientation,
    isLessThanMedium,
    browser,
    bookingUrl,
    homePageVideoBanner,
    pageIndex,
    formData: form,
  }), {
    toggleGlobalLoaderAction: toggleGlobalLoader,
    syncFiltersAction: syncFilters,
    setSubmitFailedAction: setSubmitFailed,
    setSubmitSucceededAction: setSubmitSucceeded,
    codeApplyAction: codeApply,
    codeChangeAction: codeChange,
    setSearchUrlHolder,
  },
)(reduxForm({
  form: SEARCH_FILTERS_FORM,
  destroyOnUnmount: true,
})(Wrapper))
